
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/quickstart/glossary",
      function () {
        return require("private-next-pages/docs/quickstart/glossary.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/quickstart/glossary"])
      });
    }
  